var render = function (_h,_vm) {var _c=_vm._c;return _c('tr',[_c('td',{staticClass:"no-border",attrs:{"colspan":_vm.props.yearsLength * _vm.props.columnMultiply + 3}},[_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }